// Ukrainian dictionary for the landing bundle.
//
// This is the canonical source of UI copy. Keys are stable PascalCase /
// dot-namespaced tokens (NOT the Ukrainian phrase) so the default culture can
// be swapped or more languages added cleanly.
//
// To add a new key:
//  1) add it here in `dict`
//  2) add an English translation with the same key in en.js
//  3) replace the hardcoded string in landing.jsx with `t("path.to.key")`
//     (or `t("path.to.key", { name: "..." })` for placeholders)

export const dict = {
  brand: {
    eyebrow: "AI Bot · для медичних клінік",
    name: "AI Bot",
  },

  hero: {
    titleAccent: "AI-реєстратор",
    titleRest: "для медичних клінік",
    lede:
      "Рецепція перевантажена дзвінками? AI-бот відповідає пацієнтам 24/7 у Telegram, Instagram, на сайті і передає складні запити адміністратору з повним контекстом діалогу.",
    ctaTry: "Спробувати безкоштовно",
    ctaLogin: "Увійти",
    metric247Label: "відповіді пацієнтам",
    metricLoadValue: "−60%",
    metricLoadLabel: "навантаження на рецепцію",
    metricChannelsValue: "5 каналів",
    metricChannelsLabel: "в одному інбоксі",
  },

  heroChat: {
    channelTitle: "Telegram · Клініка «Здоров'я+»",
    live: "● LIVE",
    rolePatient: "Ви",
    roleAi: "AI Bot",
    roleOperator: "Марія · адмін",
    nodePatient: "Пацієнт",
    nodePatientName: "Олена К.",
    nodeAi: "AI Bot",
    nodeAiRole: "Перша лінія",
    nodeOperator: "Адміністратор",
    nodeOperatorName: "Марія С.",
    msg1: "Доброго дня! Чи приймає сьогодні лікар-кардіолог?",
    msg2: "Вітаю! Сьогодні приймає д-р О. Коваль, 14:00–18:00. Консультація — 950 ₴.",
    msg3: "А можна записатись зі страховкою \"ВУСО\"?",
    msg4: "Передаю вас адміністратору — він уточнить умови за вашим полісом.",
    msg5: "Доброго дня, Олено! Бачу ваш запит. Так, ми працюємо з \"ВУСО\".",
  },

  safety: {
    strong: "AI не ставить діагнози і не призначає лікування.",
    text: "Асистент відповідає на інформаційні запитання та передає медичні питання лікарю. Кожна взаємодія — під наглядом клініки.",
  },

  benefits: {
    eyebrow: "Переваги",
    titleAccent: "Менше дзвінків.",
    titleMuted: "Більше уваги для пацієнтів.",
    items: [
      { title: "Працює 24/7", body: "Пацієнти отримують відповіді вночі, у вихідні та свята — без затримок." },
      { title: "Усі канали в одному інбоксі", body: "Сайт, Telegram, Facebook, Instagram та HelpCrunch — єдине вікно для адмінів." },
      { title: "Плавна передача оператору", body: "Коли AI не впевнений — діалог переходить до людини разом із контекстом." },
      { title: "Інтеграція з Clinica Web", body: "Прайс, лікарі, послуги, розклад — актуальні дані напряму з вашої МІС." },
      { title: "Семантична база знань", body: "Статті, FAQ, філії, страхові партнери — AI навчається на ваших даних." },
      { title: "Безпека медкомунікації", body: "Без діагнозів, без порад щодо лікування. Персональні дані — під контролем." },
    ],
  },

  how: {
    eyebrow: "Як це працює",
    titleAccent: "AI — перша лінія.",
    titleMuted: "Людина — там, де потрібна.",
    steps: [
      { title: "Пацієнт пише в будь-якому каналі", body: "Messenger сайту, Telegram-бот, Facebook, Instagram Direct. Одне повідомлення — одна система." },
      { title: "AI Bot відповідає за секунди", body: "Асистент використовує ваші дані з Clinica Web та базу знань: послуги, ціни, лікарі, розклад, філії, статті." },
      { title: "Складний запит — передача оператору", body: "Якщо питання виходить за межі — або пацієнт просить людину — адміністратор отримує діалог разом із контекстом." },
      { title: "Синхронізація з МІС", body: "Уточнення щодо запису, страхових полісів, результатів — у зв'язці з медичною інформаційною системою." },
    ],
    visual: {
      channelsTitle: "Омніканальний інбокс",
      aiTitle: "AI знає вашу клініку",
      handoffTitle: "Передача зі збереженням контексту",
      syncTitle: "Прямий зв'язок з Clinica Web",
      aiQueryLabel: "Запит:",
      aiQuery: "«Скільки коштує УЗД щитовидки і хто приймає?»",
      aiSrc1: "Прайс Clinica Web · «УЗД щитоподібної залози — 650 ₴»",
      aiSrc2: "Розклад · «д-р Л. Кравчук, вт/чт, 9:00–13:00»",
      aiSrc3: "Стаття «Підготовка до УЗД» · база знань",
      aiAnswer1: "УЗД щитоподібної залози коштує",
      aiAnswer2: ". Приймає д-р Л. Кравчук, вт і чт, 9:00–13:00. Підготовка не потрібна.",
      inboxRows: [
        { name: "Олена К.", preview: "Чи приймає кардіолог сьогодні?", t: "14:02" },
        { name: "Andriy B.", preview: "Скільки коштує УЗД щитовидки?", t: "13:48" },
        { name: "Гість з сайту", preview: "Чи є філія на Оболоні?", t: "13:30" },
        { name: "Natalia R.", preview: "Як підготуватись до аналізу крові?", t: "12:55" },
      ],
      handoffName: "Олена К.",
      handoffDialog: "Telegram · діалог #2481",
      handoffTag: "Передано",
      handoffSummary: "Резюме від AI",
      handoffPoints: [
        "Питання про прийом кардіолога",
        "Цікавиться страховкою «ВУСО»",
        "Рекомендовано підтвердити умови",
      ],
      handoffAssigned: "Призначено:",
      handoffAssignee: "Марія С.",
      handoffTime: "22 сек тому",
      syncAiName: "AI Bot",
      syncAiRole: "Асистент",
      syncCwName: "Clinica Web",
      syncCwRole: "МІС",
      syncRow1: "Послуги, ціни",
      syncRow2: "Лікарі, розклад",
      syncRow3: "Оновлення в реальному часі",
      syncRow4: "Філії, страхові",
    },
  },

  features: {
    eyebrow: "Можливості",
    titleAccent: "Усе, що треба клініці",
    titleMuted: "для сучасної комунікації.",
    f1: {
      tag: "Живий чат",
      title: "Єдиний інбокс для адміністраторів",
      body: "Уся переписка з усіх каналів — в одній панелі. Історія діалогів, швидкі відповіді, шаблони, переведення між операторами, нотатки та теги. Працює в браузері — без встановлення.",
      list: [
        "Приєднуйте оператора до будь-якого діалогу",
        "Швидкі відповіді та шаблони для типових запитів",
        "Теги, нотатки, пріоритети — за вашими процесами",
      ],
    },
    f2: {
      tag: "Навчання на ваших даних",
      title: "AI відповідає як ваш адміністратор",
      body: "Підключіть Clinica Web, завантажте статті та FAQ — AI автоматично побудує базу знань. Використовується векторний пошук, тож асистент цитує джерела і не вигадує факти.",
      list: [
        "Автоматичне оновлення даних з МІС",
        "Прозорість: видно, з якого джерела відповідь",
        "Тон голосу та глосарій налаштовуються",
      ],
    },
    f3: {
      tag: "Адмін-панель",
      title: "Керування контентом і правилами — без розробників",
      body: "Редагуйте відповіді, додавайте філії, змінюйте правила ескалації, підключайте нові канали. Мультитенантна архітектура — мережа клінік працює з однієї панелі з розмежуванням ролей.",
      list: [
        "Ролі: власник, менеджер, адміністратор, оператор",
        "Аналітика: діалоги, SLA, теми, джерела",
        "Журнал аудиту всіх змін",
      ],
    },
    inboxMock: {
      title: "Інбокс · AI Bot",
      sideHeader: "Діалоги",
      lastSeen: "останнє: 2 хв тому",
      headerSub: "Telegram · кардіологія",
      tag1: "запис",
      tag2: "страхова",
      msg1: "Чи приймає кардіолог сьогодні?",
      msg2: "Так, д-р О. Коваль, 14:00–18:00. Записати вас?",
      msg3: "Так, і ще зі страховкою \"ВУСО\"",
      sysHandoff: "AI передав діалог адміністратору Марії",
      msg4: "Доброго дня! Ми працюємо з \"ВУСО\", зараз оформимо.",
      names: ["Олена К.", "Andriy B.", "Natalia R.", "Гість #4412", "Ірина О."],
    },
    kbMock: {
      title: "База знань",
      head: "Джерела AI",
      sub: "5 активних · індексація знань увімкнена",
      add: "Додати",
      sources: [
        { type: "МІС", title: "Прайс послуг · 284 позиції", updated: "оновлено щогодини" },
        { type: "МІС", title: "Розклад лікарів · 42 лікарі", updated: "оновлено щогодини" },
        { type: "Стаття", title: "Підготовка до аналізів", updated: "v3 · 12 днів тому" },
        { type: "FAQ", title: "Страхові партнери", updated: "v5 · 3 дні тому" },
        { type: "Дані", title: "Філії · адреси, графік", updated: "вручну" },
      ],
    },
    adminMock: {
      title: "Налаштування · Клініка «Здоров'я+»",
      stat1: "Діалогів за тиждень",
      stat2: "Відсоток AI-відповідей",
      stat3: "Середній час відповіді",
      stat3Value: "2.4 с",
      section: "Канали",
      connected: "Підключено",
      channels: [
        { name: "Віджет на сайті" },
        { name: "Telegram · @zdoroviaplus_bot" },
        { name: "Facebook Messenger" },
        { name: "Instagram Direct" },
      ],
    },
  },

  integrations: {
    eyebrow: "Інтеграції",
    titleAccent: "Працює з тим,",
    titleMuted: "що у вас уже є.",
    primaryBadge: "Основна",
    note1: "Потрібна інша МІС або канал?",
    noteLink: "Напишіть нам",
    note2: "— ми розглянемо інтеграцію індивідуально.",
    items: [
      { name: "Clinica Web", desc: "Медична інформаційна система" },
      { name: "Telegram", desc: "Бот та особисті повідомлення" },
      { name: "Facebook", desc: "Messenger сторінки клініки" },
      { name: "Instagram", desc: "Direct повідомлення" },
      { name: "Віджет на сайті", desc: "Живий чат на вашому сайті" },
      { name: "HelpCrunch", desc: "Підключення існуючих чатів" },
    ],
  },

  cases: {
    eyebrow: "Кейси",
    titleAccent: "Результати медичних клінік,",
    titleMuted: "центрів та лабораторій.",
    sub: "Понад 50 медичних закладів вже автоматизували свою комунікацію з пацієнтами",
    photoLabel: "фото",
    items: [
      {
        tag: "Мережа клінік",
        title: "Мережа «Здоров'я+»",
        body: "6 філій, 80+ лікарів. AI відповідає на питання про послуги, ціни і розклад по всіх філіях. Рецепція отримує тільки цільові дзвінки.",
        metric: "−54% часу на обробку повідомлень",
      },
      {
        tag: "Діагностичний центр",
        title: "Лабораторія «МедТест»",
        body: "Пацієнти запитують про підготовку до аналізів та терміни готовності. AI відповідає на 80% запитів, лаборанти — лише коли потрібна людина.",
        metric: "80% автоматичних відповідей",
      },
      {
        tag: "Спеціалізований центр",
        title: "Центр репродукції «Ліра»",
        body: "Чутлива тема — важлива тактовність. AI дає загальну інформацію, а делікатні питання одразу передає координатору з емпатичним промптом.",
        metric: "24/7 підтримка пацієнтів",
      },
    ],
  },

  faq: {
    eyebrow: "Поширені запитання",
    titleAccent: "Відповіді на те,",
    titleMuted: "про що зазвичай питають.",
    items: [
      { q: "Чи ставить AI діагнози?", a: "Ні. AI відповідає тільки на інформаційні запитання: про послуги, ціни, лікарів, розклад, підготовку до процедур. Медичні питання автоматично передаються лікарю або адміністратору." },
      { q: "Як працює інтеграція з Clinica Web?", a: "Через офіційне API. Синхронізуємо послуги, прайс, лікарів, розклад і філії. Дані оновлюються онлайн, AI завжди має актуальну інформацію. Впровадження займає 3–5 днів." },
      { q: "Чи в безпеці персональні дані пацієнтів?", a: "Так. Сервіс відповідає вимогам GDPR та українського законодавства про захист даних. Дані зберігаються в ЄС, шифруються, доступ надається за ролями. Можливий варіант розгортання на вашій інфраструктурі." },
      { q: "Що буде, якщо AI не знає відповіді?", a: "Асистент чесно каже, що не впевнений, і одразу передасть діалог адміністратору. Пацієнт не залишається наодинці, контекст бесіди зберігається, людина бачить всю історію." },
      { q: "Скільки часу займає підключення?", a: "Для однієї клініки зі стандартним набором каналів — 5–7 робочих днів. Мережа з інтеграцією МІС — 2–3 тижні. Навчання персоналу включено у вартість." },
      { q: "Чи можна навчити AI на власних матеріалах?", a: "Так. Завантажуйте статті, FAQ, внутрішні регламенти, AI використовує їх як джерела. Тон голосу, глосарій і правила ескалації повністю під вашим контролем." },
      { q: "Чи підходить AI Bot для стоматологічної клініки?", a: "Так. AI Bot адаптується до будь-якого типу медичного закладу, від стоматології та лабораторії до спеціалізованих центрів. Ви самостійно налаштовуєте базу знань під профіль вашої клініки." },
      { q: "Чи можна підключити без Clinica Web?", a: "Так. Ви можете завантажити прайс, розклад та FAQ вручну або через файли. Clinica Web — рекомендована інтеграція для автоматичного оновлення даних." },
      { q: "Скільки коштує AI Bot для клініки?", a: "Перші 14 днів безкоштовно. Надалі тарифи залежать від кількості каналів та обсягу діалогів. Деталі дізнавайтеся у нашого менеджера." },
      { q: "Чи підходить рішення для мережі з кількох філій?", a: "Так. Архітектура бота дозволяє керувати всіма філіями з єдиної адмін-панелі з розмежуванням прав доступу." },
    ],
  },

  cta: {
    eyebrow: "Почніть за 5 хвилин",
    title1: "Автоматизуйте реєстратуру",
    title2: "вашої клініки вже сьогодні",
    sub: "Приєднайтеся до 50+ клінік, які вже скоротили час обробки запитів.",
    list: [
      "Підтримка Google Workspace та Microsoft 365",
      "Майстер підключення Clinica Web",
      "Безкоштовний тестовий період 14 днів",
      "Допомога на кожному кроці налаштування",
    ],
    btnTry: "Спробувати безкоштовно",
    btnDemo: "Запросити демо",
    deviceTitle: "AI Bot",
    deviceSub: "Зареєструйте ваш медичний заклад",
    deviceCap: "Оберіть спосіб входу",
    google: "Продовжити через Google",
    microsoft: "Продовжити через Microsoft",
  },

  nav: {
    benefits: "Переваги",
    how: "Як працює",
    features: "Можливості",
    integrations: "Інтеграції",
    cases: "Кейси",
    faq: "FAQ",
    login: "Увійти",
    createAccount: "Створити акаунт",
    languageLabel: "Language",
  },

  footer: {
    tagline: "AI-комунікаційна платформа для медичних клінік, діагностичних центрів і лабораторій.",
    colProduct: "Продукт",
    productFeatures: "Можливості",
    productIntegrations: "Інтеграції",
    productHow: "Як працює",
    colClinics: "Клініки",
    clinicsCases: "Кейси",
    clinicsRegister: "Створити акаунт",
    clinicsFaq: "FAQ",
    colCompany: "Компанія",
    companyAbout: "Про нас",
    companyBlog: "Блог",
    companyContacts: "Контакти",
    colLegal: "Правове",
    legalPrivacy: "Політика даних",
    legalTerms: "Угода користувача",
    legalSecurity: "Безпека",
    copyright: "© 2026 AI Bot. Зроблено для української медицини.",
    disclaimer: "AI не замінює лікаря",
  },

  tweaks: {
    title: "Tweaks",
    theme: "Тема",
    scheme: "Колірна схема",
  },
};
